import { IRootState } from '../../../store'

export const getPcrErrorSelector = (state: IRootState): string | null => state.pcr.exception
